import global from './global.ts'
import tooltip from './tooltip/index.ts'

import type { PrimeVuePTOptions } from 'primevue/config'

const passThrough: PrimeVuePTOptions = {
  directives: {
    tooltip,
  },
  global,
}

export default passThrough
